// BookingTypeSelector.js with full width
import React from 'react';
import {
  Box,
  Typography,
  ToggleButtonGroup,
  ToggleButton
} from '@mui/material';
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import DeskIcon from '@mui/icons-material/Desk';

const BookingTypeSelector = ({
  enabledHD,
  enabledMR,
  bookingType,
  handleBookingTypeChange,
  availableBookingTypes,
  compact = false
}) => {
  return (
    <Box sx={{ mb: compact ? 2 : 3, width: '100%' }}>
      <ToggleButtonGroup
        value={bookingType}
        exclusive
        onChange={handleBookingTypeChange}
        aria-label="booking type"
        size={compact ? "small" : "medium"}
        sx={{ 
          width: '100%',
          '& .MuiToggleButtonGroup-grouped': {
            flex: 1, // Make buttons take equal width
            '&:not(:first-of-type)': {
              borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
            },
          }
        }}
      >
        {availableBookingTypes.includes('HD') && enabledHD && (
          <ToggleButton 
            value="HD" 
            aria-label="hot desk"
            sx={{ 
              py: 1.5, // Add more vertical padding
              justifyContent: 'center'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: compact ? 0.5 : 1 }}>
              <DeskIcon fontSize={compact ? "small" : "medium"} />
              <Typography variant={compact ? "body2" : "body1"}>HOT DESK</Typography>
            </Box>
          </ToggleButton>
        )}
        {availableBookingTypes.includes('MR') && enabledMR && (
          <ToggleButton 
            value="MR" 
            aria-label="meeting room"
            sx={{ 
              py: 1.5, // Add more vertical padding
              justifyContent: 'center'
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: compact ? 0.5 : 1 }}>
              <MeetingRoomIcon fontSize={compact ? "small" : "medium"} />
              <Typography variant={compact ? "body2" : "body1"}>MEETING ROOM</Typography>
            </Box>
          </ToggleButton>
        )}
      </ToggleButtonGroup>
    </Box>
  );
};

export default BookingTypeSelector;